import { IClientTicketFull } from '@bustickus/models-client';
import { ApiTickets } from 'common/api';
import { handleAuthError } from 'common/handlers';
import { Button, Flex, Loader, Message } from 'components';
import { useState } from 'react';
import { SpoilerCard } from 'shared/components';
import * as bi from 'react-bootstrap-icons';

interface IProps {
  ticket: IClientTicketFull;
}

function DownloadCard(props: IProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);

  const downloadAvailable = props.ticket.status === 'active' || props.ticket.status === 'archive';
  const ticketPdfLink = token != null ? ApiTickets.getInstance().getPdfLink(props.ticket.id, token) : null;

  const loadTicketTocken = async () =>
    await handleAuthError(async () => {
      const api = ApiTickets.getInstance();
      const pdf = await api.getPdfTocket(props.ticket.id);

      if (token == null) {
        setToken(pdf.token);
      }
    });

  const handleOpenClick = () => {
    if (!open && token == null && downloadAvailable) {
      loadTicketTocken();
    }

    setOpen(!open);
  };

  return (
    <SpoilerCard
      title='Скачать билет'
      open={open}
      onOpenClick={handleOpenClick}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <p>
          Вы можете сохранить свой билет на устройство в формате PDF-документа. При возникновении проблем с посадкой на
          автобус, у вас под рукой будет оффлайн-версия билета на вашем устройтсве или в распечатанном виде
        </p>

        {!downloadAvailable && (
          <Message
            type='error'
            title='Скачивание недоступно'
          >
            Вы не можете скачивать билеты, которые не были оплачены, деньги за которые были возвращены и которые только
            ожидают оплаты!
          </Message>
        )}

        <Button
          disabled={token == null}
          href={ticketPdfLink}
          color='red'
          size='small'
        >
          <Flex
            justifyContent='center'
            gap={5}
            alignItems='center'
          >
            {downloadAvailable && token == null && (
              <Loader
                size='default'
                variant='line'
                color='background-02'
              />
            )}
            {(!downloadAvailable || token != null) && (
              <>
                <bi.Download />
                <span>Скачать билет в формате PDF</span>
              </>
            )}
          </Flex>
        </Button>
      </Flex>
    </SpoilerCard>
  );
}

export default DownloadCard;
